// views/Components/DotLoader.js
// Kept for its existing call sites. The implementation is the shared one in
// components/Loading.jsx, so the dashboard has one loading indicator rather
// than three that disagree on size, colour and whether they are visible.
import React from "react";
import Loading from "../../components/Loading";

const DotLoader = () => <Loading size="panel" />;

export default DotLoader;
